// removed by extract-text-webpack-plugin
module.exports = {"gw_offering_summary":"MobileCoverageSummary-hashed__gw_offering_summary__jZnJ5","gw_summarized_coverage":"MobileCoverageSummary-hashed__gw_summarized_coverage__14GDS","gw_offering_header_accordion_label":"MobileCoverageSummary-hashed__gw_offering_header_accordion_label__1NBHo"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/common/directives/CommonOfferingSelection/mobileQuoteView/mobile-coverage-summary/MobileCoverageSummary-hashed.scss
// module id = 1248
// module chunks = 0